import { render, staticRenderFns } from "./Dpsj.vue?vue&type=template&id=b12c250c&scoped=true&"
import script from "./Dpsj.vue?vue&type=script&lang=js&"
export * from "./Dpsj.vue?vue&type=script&lang=js&"
import style0 from "./Dpsj.vue?vue&type=style&index=0&id=b12c250c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c250c",
  null
  
)

export default component.exports